/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { GUEST_ORDER_FRAGMENT } from '@/order/api/graphql/GuestOrderFragment.graphql';

export const PLACE_ORDER_FRAGMENT = /* GraphQL */ `
  fragment PLACE_ORDER_FRAGMENT on PlaceOrderOutput {
    errors {
      code
      message
    }
    orderV2 {
      ...GUEST_ORDER_FRAGMENT
    }
  }

  ${GUEST_ORDER_FRAGMENT}
`;
